<template>
  <div class="registered-company-info">
    <translate tag="strong">Our company details</translate>
    <br />
    <translate>Company name</translate>
    <br />
    <translate
      >Pitchup.com Ltd, trading as Pitchup.com. Registered in England & Wales
      (company number 06636463).</translate
    >
    <br />
    <br />
    <translate tag="strong">Registered office</translate>
    <br />
    Zeeta House,
    <br />
    200 Upper Richmond Road,
    <br />
    Putney, London. SW15 2SH
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.registered-company-info {
  border-top: 1px solid #dedede;
  margin-top: 6em;
  padding-top: 1em;
  font-size: var(--body);
}
</style>
